import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Link from '@mui/material/Link';
import { useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { useContext, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { Snackbar } from 'Components/Snackbar';
import { ColorModeContext } from 'lib/contexts';
import { useInitPlug } from 'lib/hooks';
import { initPlugState } from 'lib/recoil/atoms';

export const FloatingActionButtons = () => {
	const theme = useTheme();
	const { connectWallet } = useInitPlug();
	const { isConnected, principalId } = useRecoilValue(initPlugState);
	const { toggleColorMode } = useContext(ColorModeContext);
	const [principalAddressCopied, setPrincipalAddressCopied] = useState(false);

	const renderPrincipalId = () => {
		if (principalId) {
			const first = principalId.split('-')[0];
			const last = principalId.split('-').pop();

			return (
				<>
					{first}...{last}
				</>
			);
		}

		return <>Connect wallet</>;
	};

	const handleOnWalletClick = async () => {
		if (!isConnected) {
			await connectWallet();
			return;
		}

		if (principalId) {
			await navigator.clipboard.writeText(principalId);
			setPrincipalAddressCopied(true);
		}
	};

	return (
		<>
			<Box
				sx={{
					position: 'fixed',
					top: '1rem',
					right: '2.5rem',
					'& > :not(style)': { m: 0.5 }
				}}
			>
				<Link
					component={RouterLink}
					to='/'
					sx={{
						textDecoration: 'unset',
						color: 'white'
					}}
				>
					<Fab color='primary' variant='extended' aria-label='marketplace'>
						<StoreOutlinedIcon sx={{ mr: 1 }} />
						Marketplace
					</Fab>
				</Link>
				<Link
					component={RouterLink}
					to='/collections'
					sx={{
						textDecoration: 'unset',
						color: 'white'
					}}
				>
					<Fab color='primary' variant='extended' aria-label='collections'>
						<CollectionsOutlinedIcon sx={{ mr: 1 }} />
						My collections
					</Fab>
				</Link>
				<Tooltip arrow title={isConnected ? 'Copy address' : ''}>
					<Fab color='primary' variant='extended' aria-label='wallet' onClick={handleOnWalletClick}>
						<AccountBalanceWalletOutlinedIcon sx={{ mr: 1 }} />
						{renderPrincipalId()}
					</Fab>
				</Tooltip>
				
			</Box>
			<Snackbar message='Copied' open={principalAddressCopied} onClose={() => setPrincipalAddressCopied(false)} />
		</>
	);
};
